<template>
    <div class="header">
        <div class="logo pull-left logo-container">
            <img src="../../assets/images/lango-logo-white.png" style="width: 80px; max-width: 80px;">
        </div>
        <div class="user-section">
            <div class='user-image'><img :src="avatarUrl" /></div>
            <div class='user-name'>
                <div class="dropdown is-hoverable">
                  <div class="dropdown-trigger">
                    <button class="button" aria-haspopup="true" aria-controls="user-menu">
                      <span>{{ user.first_name }}</span>
                      <span class="icon is-small">
                        <i class="fas fa-angle-down" aria-hidden="true"></i>
                      </span>
                    </button>
                  </div>
                  <div class="dropdown-menu" id="user-menu" role="menu">
                    <div class="dropdown-content" style="position: absolute; left: 0;">
<!--                       <div class="dropdown-item">
                        <span class="user-logout" v-on:click="profile">Profile</span>
                      </div> -->
                      <div class="dropdown-item">
                        <span class="user-logout" v-on:click="profile">Account</span>
                        <span class="user-logout" v-on:click="logout">Logout</span>
                      </div>
                    </div>
                  </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {    
    data () {
        return {
            
        }
    },

    computed: {
        // ...mapState('auth', {
        //     user: state => state.user,
        // }),

        ...mapState('user', {
            user: state => state.user,
        }),

        // ...mapGetters('auth', {
        //     avatarUrl: 'getAvatarUrl'
        // }),

        ...mapGetters('user', {
            avatarUrl: 'getProfileImageUrl'
        }),
    },

    methods: {
        logout(){
          VueStore.dispatch('auth/logout');
        },

        /*
         * Show profile modal
         */
        profile(){
          VueStore.dispatch('profile/setBoolean', {key: 'showProfile', bool: true});
        }
    },

    mounted(){
        // sessionStorage.setItem("ACTIVE-HEADER-TAB", 'home');

        // get user data
        VueStore.dispatch('user/getUserData');
    }
}
</script>

<style scoped>
.header, .user-name .dropdown, .user-name .dropdown button{
 background-color: #29364e !important;
}
</style>